import { Chip } from '@mui/material';

import {
  RenderWorkerInfo,
  getHiredButton,
  getInvitedButton,
} from './StaffingUtils';
import WorkerProfileRowMobileView from './WorkerProfileRowMobileView';

import Stack from '@/components/Stack';
import { TableRow, TableCell } from '@/elements/Table';
import useMediaQuery from '@/hooks/useMediaQuery';

type Mode = 'add' | 'remove';
type StaffingWorkerProfileRowProps = {
  worker: Record<string, any>;
  isClientAdmin: boolean;
  hireButtonClick: (worker: Record<string, any>, mode?: Mode) => void;
  inviteButtonClick: (worker: Record<string, any>, mode?: Mode) => void;
  isHiredButton?: boolean;
  isInvitedButton?: boolean;
  buttonsDisableCheck?: boolean;
  isLTA: boolean;
  skillName: string;
  modalView?: boolean;
  inviteButtonDisable?: boolean;
};

const StaffingWorkerProfileRow = ({
  worker,
  isClientAdmin,
  hireButtonClick,
  inviteButtonClick,
  isHiredButton,
  isInvitedButton,
  buttonsDisableCheck,
  isLTA,
  skillName,
  modalView = false,
  inviteButtonDisable,
}: StaffingWorkerProfileRowProps) => {
  const phoneOnly = useMediaQuery('(max-width: 559px)');
  return (
    <>
      {phoneOnly ? (
        <WorkerProfileRowMobileView
          key={worker.id}
          buttonsDisableCheck={buttonsDisableCheck}
          hireButtonClick={hireButtonClick}
          inviteButtonClick={inviteButtonClick}
          inviteButtonDisable={inviteButtonDisable}
          isClientAdmin={isClientAdmin}
          isHiredButton={isHiredButton}
          isInvitedButton={isInvitedButton}
          isLTA={isLTA}
          skillName={skillName}
          worker={worker}
        />
      ) : (
        <TableRow key={worker.id} aria-haspopup="true" css={undefined}>
          <TableCell>
            <RenderWorkerInfo
              isClientAdmin={isClientAdmin}
              modalView={modalView}
              skillName={skillName}
              workerInfo={worker}
            />
          </TableCell>
          {!modalView && (
            <>
              <TableCell>{worker?.selectedSkillShift}</TableCell>
              <TableCell>{worker?.shiftsWith}</TableCell>
            </>
          )}
          <TableCell css={modalView ? { width: '240px' } : undefined}>
            <Stack
              css={{ flexDirection: 'row', alignItems: 'center' }}
              gap={10}
            >
              {!!worker.hasConflicts && (
                <Chip
                  label={
                    worker.conflictDates?.length
                      ? `Unavailable ${worker.conflictDates.join(', ')}`
                      : 'Unavailable'
                  }
                  size="small"
                  sx={{
                    backgroundColor: '#FEF3C7',
                    color: '#92400E',
                    fontSize: '11px',
                    height: '20px',
                    fontWeight: 500,
                    maxWidth: '200px',
                    '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                />
              )}
              {worker.hireable && (!isClientAdmin || isLTA)
                ? getHiredButton({
                    isHired: isHiredButton,
                    disable: buttonsDisableCheck,
                    handleClick: (mode) => hireButtonClick(worker, mode),
                  })
                : null}
              {worker.invitable &&
                (!isLTA || !!worker.hasConflicts) &&
                getInvitedButton({
                  isInvited: isInvitedButton,
                  disable: isHiredButton || inviteButtonDisable,
                  handleClick: (mode) => inviteButtonClick(worker, mode),
                })}
            </Stack>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default StaffingWorkerProfileRow;
